module.exports = __webpack_public_path__ + "img/step-7.0f3fe05c.jpg";